<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_student'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="d-flex justify-content-end">
                <div>
                  <router-link to="/newstudent"
                    ><b-button size="sm" variant="primary"
                      ><i class="mdi mdi-plus"></i> Add Student</b-button
                    ></router-link
                  >
                </div>
                <div>
                  <b-button
                    class="mx-2"
                    v-b-modal.new-students
                    size="sm"
                    variant="success"
                    ><i class="mdi mdi-upload"></i> Import Students</b-button
                  >
                </div>
                <div>
                  <a
                    download="StudentsTemplate.csv"
                    :href="getTemplate('StudentsTemplate.csv')"
                    ><button class="btn btn-sm btn-secondary">
                      Download Template
                    </button></a
                  >
                </div>
                <div>
                  <router-link to="/viewarchivedstudents"
                    ><b-button size="sm" variant="info" class="mx-2"
                      ><i class="mdi mdi-plus"></i> Archived Students</b-button
                    ></router-link
                  >
                </div>
              </div>
              <div class="my-2">
                <div class="row">
                  <b-form-group class="col-md-3" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Class">
                    <v-select
                      :options="schoolclasses"
                      @input="FilterStream"
                      placeholder="Select Class"
                      v-model="schoolclass"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Stream">
                    <v-select
                      :options="schoolstreams"
                      placeholder="Select Stream"
                      v-model="schoolstream"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="text-center mt-4" v-if="schoolstream != ''">
                <h3>
                  {{ schoolclass.name }} {{ schoolstream.name }}
                  {{ schoolterm.name }} - {{ year }}
                </h3>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onTableFiltered"
                  :busy="IsBusy"
                >
                  <template #table-busy>
                    <NoDataMessage :type="emptyStateType" />
                  </template>
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(student_photo)="data">
                    <img
                      :src="getFiles(data.item.student.student_photo)"
                      height="50"
                    />
                  </template>
                  <template #cell(student_id)="data">
                    <b class="text-danger">{{
                      data.item.student.student_id
                    }}</b>
                    <br /><small style="color:red;"
                      >Card No: <b>{{ data.item.cardnumber }}</b></small
                    >
                  </template>
                  <template #cell(student)="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.last_name }}
                  </template>
                  <template #cell(address)="data">
                    {{ data.item.student.district }}
                    <small>{{ data.item.student.address }}</small>
                  </template>
                  <template #cell(gender)="data">
                    {{ data.item.student.gender }}
                  </template>
                  <template #cell(age)="data">
                    {{ data.item.age }} <small>yrs</small>
                  </template>
                  <template #cell(class)="data">
                    {{ data.item.class.name }} {{ data.item.stream.name }}
                  </template>
                  <template #cell(combination)="data">
                    <span v-if="data.item.class.level == 1">
                      <strong>{{ data.item.combination }}</strong>
                    </span>
                    <span v-else
                      ><small style="color: green;"
                        ><strong>O-LEVEL</strong></small
                      ></span
                    >
                  </template>
                  <template #cell(school_pay_code)="data">
                    {{ data.item.student.school_pay_code }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <router-link
                        :to="{
                          path: '/studentprofile',
                          query: { id: data.item.student.student_id },
                        }"
                        type="button"
                        class="btn-sm btn btn-primary"
                      >
                        <i class="mdi mdi-clipboard-text"
                          >Profile</i
                        ></router-link
                      >
                      <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.student.student_id,
                            data.item.student.first_name,
                            data.item.student.last_name,
                            data.item.student.cardnumber,
                            data.item.class,
                            data.item.stream,
                            data.item.residentialstatus,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="info"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"
                          >Edit</i
                        ></b-button
                      ><b-button
                        @click="
                          demote(
                            data.item.id,
                            data.item.class,
                            data.item.stream,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="secondary"
                        v-b-modal.demote
                      >
                        <i class="mdi mdi-account-minus-outline">demote</i>
                      </b-button>
                      <b-button
                        @click="remove(data.item.id, data.item.name)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can">delete</i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-modal
            id="new-students"
            centered
            title="Import Students"
            title-class="font-18"
            hide-footer
          >
            <form @submit.prevent="UpLoadStudents">
              <b-form-group label="Term">
                <v-select
                  :options="schoolterms"
                  placeholder="Select Term"
                  v-model="schoolterm"
                  label="name"
                ></v-select>
              </b-form-group>
              <b-form-group label="Year">
                <v-select
                  :options="years"
                  placeholder="Select Year"
                  v-model="year"
                ></v-select>
              </b-form-group>
              <b-form-group label="Class">
                <v-select
                  :options="schoolclasses"
                  @input="FilterStream"
                  placeholder="Select Class"
                  v-model="schoolclass"
                  label="name"
                ></v-select>
              </b-form-group>
              <b-form-group label="Stream">
                <v-select
                  :options="schoolstreams"
                  placeholder="Select Stream"
                  v-model="schoolstream"
                ></v-select>
              </b-form-group>
              <div class="form-group my-2">
                <label>Select the File</label>
                <input
                  type="file"
                  v-on:change="onLogoChange"
                  class="form-control"
                />
              </div>
              <div class="form-group d-flex justify-content-end">
                <b-button
                  type="button"
                  class="btn w-30"
                  variant="secondary"
                  @click="$bvModal.hide('new-student')"
                  >Close</b-button
                >
                <b-button
                  :disabled="loader"
                  type="submit"
                  class="btn ms-1 w-30"
                  variant="primary"
                >
                  <b-spinner
                    v-if="loader"
                    small
                    class="mr-1"
                    label="Small Spinner"
                  />
                  <i v-else class="fas fa-check-circle"></i> Submit</b-button
                >
              </div>
            </form>
          </b-modal>

          <b-modal
            id="edit-student"
            centered
            title="Edit Student"
            title-class="font-18"
            hide-footer
          >
            <form @submit.prevent="editStudent">
              <input v-model="id" type="hidden" />
              <label>Student ID</label>
              <b-form-input v-model="student_id" type="text"></b-form-input>
              <label>First Name</label>
              <b-form-input v-model="first_name" type="text"></b-form-input>
              <label>Last Name</label>
              <b-form-input v-model="last_name" type="text"></b-form-input>
              <label>Card Number</label>
              <b-form-input
                v-model="cardnumber"
                type="text"
                placeholder="Enter Card Number"
              ></b-form-input>
              <b-form-group label="Class">
                <v-select
                  :options="schoolclasses"
                  @input="FilterStream"
                  placeholder="Select Class"
                  v-model="schoolclass"
                  label="name"
                ></v-select>
              </b-form-group>
              <b-form-group label="Stream">
                <v-select
                  :options="schoolstreams"
                  placeholder="Select Stream"
                  v-model="schoolstream"
                  label="name"
                ></v-select>
              </b-form-group>
              <label>Section</label>
              <select v-model="residentialstatus" class="form-control">
                <option value="Boarding">Boarding</option>
                <option value="Day">Day</option>
              </select>
              <div class="form-group d-flex justify-content-end">
                <b-button
                  type="button"
                  class="btn w-30"
                  variant="secondary"
                  @click="$bvModal.hide('edit-student')"
                  >Close</b-button
                >
                <b-button type="submit" class="btn ms-1 w-30" variant="primary"
                  ><i class="fas fa-check-circle"></i> YES</b-button
                >
              </div>
            </form> </b-modal
          ><b-modal
            id="demote-student"
            centered
            title="Demote Student"
            title-class="font-18"
            hide-footer
          >
            <form @submit.prevent="demoteStudent">
              <input v-model="id" type="hidden" />
              <strong style="text-align: center;"
                >Are you sure you want to demote the student ?</strong
              ><br />
              <b-form-group label="Class">
                <v-select
                  :options="schoolclasses"
                  @input="FilterStream"
                  placeholder="Select Class"
                  v-model="schoolclass"
                  label="name"
                ></v-select>
              </b-form-group>
              <b-form-group label="Stream">
                <v-select
                  :options="schoolstreams"
                  placeholder="Select Stream"
                  v-model="schoolstream"
                  label="name"
                ></v-select
              ></b-form-group>
              <div class="form-group d-flex justify-content-end">
                <b-button
                  type="button"
                  class="btn w-30"
                  variant="secondary"
                  @click="$bvModal.hide('demote-student')"
                  >Close</b-button
                >
                <b-button type="submit" class="btn ms-1 w-30" variant="primary"
                  ><i class="fas fa-check-circle"></i> YES</b-button
                >
              </div>
            </form>
          </b-modal>

          <b-modal
            id="delete-student"
            centered
            title="Delete Student"
            title-class="font-18"
            hide-footer
          >
            <form @submit.prevent="removeStudent">
              <input v-model="id" type="hidden" />
              Are you sure you want to delete the student ?
              <div class="form-group d-flex justify-content-end">
                <b-button
                  type="button"
                  class="btn w-30"
                  variant="secondary"
                  @click="$bvModal.hide('delete-student')"
                  >Close</b-button
                >
                <b-button type="submit" class="btn ms-1 w-30" variant="primary"
                  ><i class="fas fa-check-circle"></i> YES</b-button
                >
              </div>
            </form>
          </b-modal>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
//import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import NoDataMessage from "@/components/NoDataMessage.vue";
import { emptyStatesMixin } from "@/state/emptyStatesMixin";
import {
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
  studentComputed,
  studentMethods,
} from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  mixins: [emptyStatesMixin],
  page: {
    title: "Students",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    NoDataMessage,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Students",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Students", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student_photo", label: "Photo", visible: true },
        { key: "learnernumber", label: "LIN", visible: true },
        { key: "student_id", label: "Student ID", visible: true },
        { key: "student", label: "Name", visible: true },
        { key: "class", label: "Class", visible: true },
        { key: "combination", label: "Combination", visible: true },
        { key: "gender", label: "Gender", visible: true },
        { key: "age", label: "Age", visible: true },
        { key: "address", label: "Address", visible: true },
        { key: "residentialstatus", label: "Section", visible: true },
        { key: "school_pay_code", label: "SchoolPay Code", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      name: "",
      residentialstatus: "",
      student: "",
      student_id: "",
      schoolterm: "",
      schoolclass: "",
      schoolstream: "",
      schoolstreams: [],
      year: new Date().getFullYear(),
      loader: false,
      first_name: "",
      last_name: "",
      importstudents: "",
      learnernumber: "",
      cardnumber: "",
      combination: "",
      requiresFilter: true,
    };
  },
  computed: {
    ...studentComputed,
    ...schoolclassComputed,
    ...schooltermComputed,
    List() {
      return this.students.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.students.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.students.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
    this.TotalRows = this.students.length;
    this.isBusy = false;
    this.schoolterm = this.schoolterms.find((option) => option.active == 1);
  },
  methods: {
    ...studentMethods,
    ...schoolclassMethods,
    ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onLogoChange(e) {
      this.importstudents = e.target.files[0];
    },
    async UpLoadStudents() {
      this.loader = true;
      const config = { headers: { "content-type": "multipart/form-data" } };
      let formData = new FormData();
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("schoolstream", this.schoolstream.id);
      formData.append("students", this.importstudents);
      let url = "/uploadstudents";
      await axios.post(url, formData, config).then((response) => {
        if (response.status == 200) {
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
          this.$bvModal.hide("new-students");
          this.importstudents = "";
          this.schoolclass = "";
          this.schoolstream = "";
          this.loader = false;
        }
      });
    },
    edit(
      id,
      student_id,
      first_name,
      last_name,
      cardnumber,
      schoolclass,
      schoolstream,
      residentialstatus,
    ) {
      this.id = id;
      this.student_id = student_id;
      this.first_name = first_name;
      this.last_name = last_name;
      this.cardnumber = cardnumber;
      this.schoolclass = schoolclass;
      this.schoolstream = schoolstream;
      this.residentialstatus = residentialstatus;
      this.FilterStream();
      this.$bvModal.show("edit-student");
    },
    remove(id) {
      this.id = id;
      this.$bvModal.show("delete-student");
    },
    demote(id, schoolclass, schoolstream) {
      this.id = id;
      this.schoolclass = schoolclass;
      this.schoolstream = schoolstream;
      this.$bvModal.show("demote-student");
    },
    async editStudent() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("student_id", this.student_id);
      formData.append("first_name", this.first_name);
      formData.append("last_name", this.last_name);
      formData.append("cardnumber", this.cardnumber);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("schoolstream", this.schoolstream.id);
      formData.append("residentialstatus", this.residentialstatus);
      let url = "/updatestudent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStudents();
          this.$bvModal.hide("edit-student");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async demoteStudent() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("schoolstream", this.schoolstream.id);
      let url = "/demotestudent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStudents();
          this.$bvModal.hide("demote-student");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeStudent() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deletestudent";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStudents();
          this.$bvModal.hide("delete-student");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async FilterStream() {
      let url = `/findschoolstream/${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.schoolstreams = response.data.streams;
      });
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },
    getTemplate(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "templates/" + name;
      return imagelink;
    },
    FilterData() {
      this.markFiltersApplied();
      this.filterStudents({
        schoolterm: this.schoolterm.id,
        year: this.year,
        schoolclass: this.schoolclass.id,
        schoolstream: this.schoolstream.id,
      });
    },
  },
};
</script>
